import { api } from "./api";

const REF_KEY = "rl_ref_posts_v1"; // { [ref]: true }
const UID_KEY = "rl_uid_v1";

const REF_VALID_RE = /^[a-z0-9_-]{3,20}$/;

export function getOrCreateUid() {
  try {
    let uid = localStorage.getItem(UID_KEY);
    if (!uid) {
      uid = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(UID_KEY, uid);
    }
    return uid;
  } catch (e) {
    return "anon-" + Math.random().toString(36).slice(2);
  }
}

export function validateRef(code) {
  return !!code && REF_VALID_RE.test(String(code).trim());
}

export async function maybeTrackRefOnLocation(search) {
  try {
    const params = new URLSearchParams(search || (typeof window !== "undefined" ? window.location.search : ""));
    const ref = (params.get("ref") || "").trim().toLowerCase();
    if (!validateRef(ref)) return;

    const uid = getOrCreateUid();
    let posted = {};
    try {
      posted = JSON.parse(localStorage.getItem(REF_KEY) || "{}");
    } catch (e) {}

    if (posted[ref]) return; // already posted for this ref

    await api.post(`/referrals/track`, { ref, uid });
    posted[ref] = true;
    localStorage.setItem(REF_KEY, JSON.stringify(posted));
  } catch (e) {
    // swallow to avoid breaking navigation
  }
}